import { UIRect } from './types';

export function uiAddRects(...rs: UIRect[]) {
    const ret: UIRect = [0, 0, 0, 0];

    for(const r of rs) {
        ret[0] += r[0];
        ret[1] += r[1];
        ret[2] += r[2];
        ret[3] += r[3];
    }

    return ret;
}

export function uiRectToCSS(r: UIRect) {
    return `${r[1]}px ${r[2]}px ${r[3]}px ${r[0]}px`;
}
